/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 5947:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

"use strict";

;// CONCATENATED MODULE: ./pages/checkout/components/checkout_referral/index.scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./pages/checkout/components/checkout_referral/index.js


;// CONCATENATED MODULE: ./pages/checkout/components/checkout_summary/index.scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./pages/checkout/components/checkout_summary/index_new.scss
// extracted by mini-css-extract-plugin

// EXTERNAL MODULE: ./images/checkout/unlimited-professors.png
var unlimited_professors = __webpack_require__(82786);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@stimulus+core@1.1.1/node_modules/@stimulus/core/dist/index.js + 1 modules
var dist = __webpack_require__(47879);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/stimulus@1.1.1/node_modules/stimulus/index.js


// EXTERNAL MODULE: ../../node_modules/.pnpm/pubsub-js@1.5.8/node_modules/pubsub-js/src/pubsub.js
var pubsub = __webpack_require__(82941);
var pubsub_default = /*#__PURE__*/__webpack_require__.n(pubsub);
;// CONCATENATED MODULE: ./utils/stimulus/index.js


// Adding trigger and on to controllers
(pubsub_default()).immediateExceptions = RAILS_ENV === 'development';
class stimulus_Controller extends (/* unused pure expression or super */ null && (Ctrl)) {
    trigger(identifier, params) {
        const parts = identifier.split('->');
        if (parts.length < 2) throw new Error('Event identifier is in an incorrect format!');
        const controller = parts[0];
        const action = parts[1];
        PubSub.publish(`stimulus.${controller}.${action}`, params);
    }
    on(action, callback) {
        const controller = this.identifier;
        PubSub.subscribe(`stimulus.${controller}.${action}`, (eventName, params)=>callback(params));
    }
    disconnect() {
        const controller = this.identifier;
        PubSub.unsubscribe(`stimulus.${controller}`);
        return super.disconnect();
    }
    constructor(){
        super(...arguments);
    }
}
class Application extends (/* unused pure expression or super */ null && (App)) {
    register(identifier, controllerConstructor) {
        if (this.controllers.indexOf(controllerConstructor) === -1) return super.register(identifier, controllerConstructor);
        else console.warning(`Controller "${identifier}" already registered!`);
    }
    constructor(){
        super(...arguments);
    }
}


;// CONCATENATED MODULE: ./pages/checkout/components/checkout_summary/index.js




class SummaryController extends (/* unused pure expression or super */ null && (Controller)) {
    connect() {
        this.on('updatePaymentDetails', this.updatePaymentDetails.bind(this));
        this.on('updateInstallmentPrice', this.updateInstallmentPrice.bind(this));
        this.on('updateLoading', this.updateLoading.bind(this));
        this.on('showInstallment', this.showInstallment.bind(this));
        this.on('hideInstallment', this.hideInstallment.bind(this));
        this.updateInstallmentPrice({
            installmentNumber: gon.flags.new_checkout_settings.startWith12X && (document.querySelector('.method-form--creditcard .installments') || document.querySelector('.q-checkout-auth')) ? gon.installment_options.length : 1,
            installmentsList: gon.installment_options
        });
        this.createMarketingBanner();
        this.selectedInstallment = 1;
    }
    toggleSection({ currentTarget }) {
        const section = currentTarget.parentNode;
        const action = section.classList.contains('q-nc-summary__section--show') ? 'remove' : 'add';
        section.classList[action]('q-nc-summary__section--show');
    }
    triggerSubmit() {
        document.querySelector('.method-form--show #checkout-submit').click();
    }
    updatePaymentDetails(method) {
        const $installments = this.element.querySelector('.price-row--installments');
        const $cash = this.element.querySelector('.price-row--cash');
        const consultBnplButtonHidden = document.querySelector('.q-payment-bnpl-consult-btn').classList.contains('hidden');
        if (method === 'bnpl') {
            if (consultBnplButtonHidden) {
                document.getElementById('bnplSummary').classList.remove('hidden');
                $installments.classList.add('price-row--show');
                $cash.classList.remove('price-row--show');
                this.updateDiscountPrice(this.selectedInstallment);
            } else {
                document.getElementById('bnplSummary').classList.add('hidden');
                $installments.classList.remove('price-row--show');
                $cash.classList.add('price-row--show');
                this.updateDiscountPrice();
            }
        } else if (method === 'creditcard') {
            document.getElementById('bnplSummary').classList.add('hidden');
            $installments.classList.add('price-row--show');
            $cash.classList.remove('price-row--show');
            this.updateDiscountPrice(this.selectedInstallment);
        } else {
            document.getElementById('bnplSummary').classList.add('hidden');
            $installments.classList.remove('price-row--show');
            $cash.classList.add('price-row--show');
            this.updateDiscountPrice();
        }
    }
    showInstallment() {
        const $installments = this.element.querySelector('.price-row--installments');
        const $cash = this.element.querySelector('.price-row--cash');
        $installments.classList.add('price-row--show');
        $cash.classList.remove('price-row--show');
    }
    hideInstallment() {
        const $installments = this.element.querySelector('.price-row--installments');
        const $cash = this.element.querySelector('.price-row--cash');
        $installments.classList.remove('price-row--show');
        $cash.classList.add('price-row--show');
    }
    updateInstallmentPrice({ installmentNumber, installmentsList }) {
        if (!installmentsList) {
            this.element.querySelector('.price-row--installments').remove();
            return;
        }
        const selectedInstallmentIdx = installmentsList.findIndex((installment)=>Number(installment.value) === Number(installmentNumber));
        const installment = installmentsList[selectedInstallmentIdx];
        const partialPrice = installment.text.split('x ')[1].split(' =')[0];
        const totalPrice = installment.text.split('= ')[1];
        let html = `<span class="installments-partial">
      ${installment.value}x <strong>${partialPrice}</strong>
    </span>`;
        if (installment.value > 1) {
            html += `<span class="installments-total">(${totalPrice})</span>`;
        }
        this.element.querySelector('.price-row--installments .price-row__price').innerHTML = html;
        this.selectedInstallment = installment.value;
        this.updateDiscountPrice(installment.value);
    }
    onCouponChange(event) {
        const $button = event.target.parentNode.querySelector('button');
        if (event.target.value) {
            $button.removeAttribute('disabled');
        } else {
            $button.setAttribute('disabled', 'disabled');
        }
    }
    onApplyCouponClick(event) {
        const $cta = event.currentTarget.parentNode;
        const $form = $cta.parentNode.querySelector('form');
        $cta.style.display = 'none';
        $form.style.display = 'flex';
    }
    updateLoading(show) {
        const $couponContainerList = this.element.querySelectorAll('.coupon');
        for (let $couponContainer of $couponContainerList){
            if (show) {
                $couponContainer.classList.add('coupon--loading');
            } else {
                $couponContainer.classList.remove('coupon--loading');
            }
        }
    }
    createMarketingBanner() {
        const flag = gon.flags.checkout_marketing_banner;
        const alreadyApplied = document.querySelector('.q-nc-summary__header__banner') !== null;
        if (flag.value && !flag.value.active || alreadyApplied) {
            return;
        }
        let settings = null;
        for(const idListAsString in flag.banners){
            // eslint-disable-next-line no-useless-escape
            const idList = idListAsString.replace(/[\[\]]/g, '').split(/,\s*/);
            if (idList.includes(String(gon.offer_id))) {
                settings = flag.banners[idListAsString];
            }
        }
        if (!settings) {
            return;
        }
        const banner = document.createElement('div');
        banner.classList.add('q-nc-summary__header__banner');
        banner.classList.add(`q-nc-summary__header__banner--${settings.color}`);
        banner.innerText = settings.text;
        this.element.querySelector('.q-nc-summary__header').prepend(banner);
    }
    updateDiscountPrice(installmentNumber) {
        const $cash = this.element.querySelector('.discount-price--cash');
        const $installments = this.element.querySelector('.discount-price--installments');
        if (!$installments) {
            return;
        }
        if (installmentNumber && installmentNumber > 1) {
            $installments.classList.add('discount-price--show');
            $cash.classList.remove('discount-price--show');
        } else {
            $installments.classList.remove('discount-price--show');
            $cash.classList.add('discount-price--show');
        }
    }
}


// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+qcx+validate@8664e60/node_modules/validate/dist/js/validate.js
var validate = __webpack_require__(2259);
var validate_default = /*#__PURE__*/__webpack_require__.n(validate);
;// CONCATENATED MODULE: ./utils/validator/index.js
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

// https://github.com/cferdinandi/validate/blob/master/package.json
// import and run validate.init();
const defaultConfig = {
    // Classes and Selectors
    selector: '[data-validate]',
    fieldClass: 'has-error',
    errorClass: 'help-block',
    // Messages
    messageValueMissing: 'Campo obrigatório.',
    messageValueMissingSelect: 'Selecione uma opção.',
    messageTypeMismatchEmail: 'Digite um e-mail válido.',
    messageTypeMismatchURL: 'Insira uma URL válida.',
    messageTooShort: 'Deve ter {minLength} caracteres ou mais.',
    messageTooLong: 'Deve ter {maxLength} caracters ou menos. Você está usando {length} caracteres.',
    messagePatternMismatch: 'Formato inválido.',
    messageBadInput: 'Insira apenas números.',
    messageStepMismatch: 'Selecione um valor válido.',
    messageRangeOverflow: 'Selecione um valor acima de {max}.',
    messageRangeUnderflow: 'Selecione um valor abaixo de {min}.',
    messageGeneric: 'Valor inválido.',
    // Custom
    createFeedbackIcon (className) {
        let node = document.createElement('i');
        node.classList.add('form-control-feedback', 'js-form-control-feedback', 'q-icon', `q-icon-${className}`);
        return node;
    },
    // Form Submission
    disableSubmit: false,
    customValidity: {
        badConfirm: {
            check (field) {
                if (!field.hasAttribute('confirm')) return false;
                const value = field.value;
                const fieldToCompare = field.getAttribute('confirm');
                const fieldToCompareValue = field.form.querySelector(`#${fieldToCompare}`).value;
                return value !== fieldToCompareValue;
            },
            message: 'O valor não é igual.'
        }
    },
    // onSubmit() {},
    // Callbacks
    beforeShowError (field) {
        const parent = field.parentNode;
        if (parent.classList.contains('form-group') || parent.classList.contains('input-group')) {
            const formControl = parent.querySelector('.js-form-control-feedback');
            parent.classList.remove('has-success', 'has-error', 'has-warning');
            parent.classList.add('has-error', 'has-feedback');
            if (formControl) formControl.remove();
            parent.appendChild(this.createFeedbackIcon('times-circle'));
        }
    },
    // afterShowError(field, error) {}
    beforeRemoveError (field) {
        const parent = field.parentNode;
        if (parent.classList.contains('form-group') || parent.classList.contains('input-group')) {
            const formControl = parent.querySelector('.js-form-control-feedback');
            parent.classList.remove('has-success', 'has-error', 'has-warning');
            parent.classList.add('has-feedback', 'has-success');
            if (formControl) formControl.remove();
            parent.appendChild(this.createFeedbackIcon('check-circle'));
        }
    }
};
const validator = {
    config: defaultConfig,
    validate: (validate_default()),
    init (config = null) {
        const expandedConfig = _extends({}, defaultConfig, config);
        validate_default().init(expandedConfig);
    }
};
/* harmony default export */ const utils_validator = (validator);

;// CONCATENATED MODULE: ./pages/password/components/password_reset_form/index.js

utils_validator.init();

;// CONCATENATED MODULE: ./utils/form_submit_toggle/index.js
class FormSubmitToggle {
    bind() {
        if (this.disableBtn) {
            this.handleSubmitBtn();
            this.$context.on('change', ()=>this.handleSubmitBtn());
        }
        this.$context.on('submit', (e)=>this.beforeSubmit(e));
    }
    handleSubmitBtn() {
        if (this.fieldsAreNotValid()) {
            this.disableSubmit();
        } else {
            this.enableSubmit();
        }
    }
    beforeSubmit(e) {
        if (this.fieldsAreNotValid()) {
            e.preventDefault();
            e.stopPropagation();
        }
    }
    enableSubmit() {
        this.$submitBtn.removeClass('disabled');
    }
    disableSubmit() {
        this.$submitBtn.addClass('disabled');
    }
    fieldsAreNotValid() {
        const invalidInputs = this.$requiredInputs.filter(function() {
            return this.checkValidity() === false;
        });
        return invalidInputs.length === 0 ? false : true;
    }
    constructor(formId, disableBtn){
        this.$context = window.jQuery(formId);
        this.$requiredInputs = this.$context.find('input').filter('[required]');
        this.$submitBtn = this.$context.find('input[type=submit]');
        this.disableBtn = disableBtn;
        this.bind();
    }
}


;// CONCATENATED MODULE: ./utils/trackers/zaraz.js
/* eslint-disable no-console */ class Zaraz {
    static enqueue(method, args) {
        if (this.isScriptLoaded) {
            window.zaraz[method](...args);
        } else {
            if (window.RAILS_ENV === 'development') {
                console.log(`Zaraz (Dev): ${method}`, args);
            }
            this.queue.push([
                method,
                args
            ]);
        }
    }
    static ecommerce(event, payload) {
        this.enqueue('ecommerce', [
            event,
            payload
        ]);
    }
    static track(event, payload) {
        this.enqueue('track', [
            event,
            payload
        ]);
    }
    static set(prop, value, params = {}) {
        this.enqueue('set', [
            prop,
            value,
            params
        ]);
    }
    static setContentGroup() {
        window.zaraz.set('content_group', gon.current_path, {
            scope: 'page'
        });
    }
    static start() {
        const intervalId = setInterval(()=>{
            if (!window.zaraz) {
                return;
            }
            Zaraz.isScriptLoaded = true;
            clearInterval(intervalId);
            this.setContentGroup();
            document.addEventListener('turbolinks:load', ()=>{
                this.setContentGroup();
            });
            this.queue.forEach(([method, args])=>{
                window.zaraz[method](...args);
            });
        }, 1000);
    }
}
Zaraz.isScriptLoaded = false;
Zaraz.queue = [];
if (window.RAILS_ENV !== 'development') {
    Zaraz.start();
}
/* harmony default export */ const zaraz = (Zaraz);

;// CONCATENATED MODULE: ./pages/session/components/login_form/index.js



utils_validator.init();
new FormSubmitToggle('#login_form');
(()=>{
    'use strict';
    const container = window.jQuery('#login_form').parents('.q-page');
    if (container.hasClass('q-checkout-auth-page')) {
        window.jQuery('#login_form').on('submit', (e)=>{
            e.stopPropagation();
            zaraz.ecommerce('Checkout Step Viewed', {
                step: 2
            });
        });
    }
})();

;// CONCATENATED MODULE: ./pages/session/components/registration_form/index.scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./utils/floating_labels/index.scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./utils/floating_labels/index.js

(function($) {
    'use strict';
    $(()=>{
        $('.js-floating-labels').on('blur', '.form-control', function() {
            const $this = $(this);
            $this.parents('.q-floating-label-wrapper').removeClass('q-floating-label-wrapper--focused');
            if ($this.val() === '') $this.parents('.q-floating-label-wrapper').removeClass('q-floating-label-wrapper--filled');
            else $this.parents('.q-floating-label-wrapper').addClass('q-floating-label-wrapper--filled');
        }).on('focus', '.form-control', function() {
            $(this).parents('.q-floating-label-wrapper').addClass('q-floating-label-wrapper--focused');
        }).find('.form-control').each(function() {
            const $this = $(this);
            let isAutofill = false;
            try {
                isAutofill = $this.is(':-webkit-autofill');
            } catch (e) {
                isAutofill = false;
            }
            if ($this.val() !== '' || isAutofill) $this.parents('.q-floating-label-wrapper').addClass('q-floating-label-wrapper--filled');
        });
    });
})(window.jQuery);

;// CONCATENATED MODULE: ./pages/session/components/registration_form/index.js



new FormSubmitToggle('#registration_form', true);

;// CONCATENATED MODULE: ./pages/checkout_auth/components/auth/index.scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./components/social_login/index.scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./components/social_login/index.js


;// CONCATENATED MODULE: ./pages/checkout_auth/components/auth/index.js






;// CONCATENATED MODULE: ./pages/checkout_auth/index.scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./utils/media_query/index.js
window.screenBreakpoints = {
    xs: 'screen and (max-width:768px)',
    sm: 'screen and (min-width:768px)',
    lt_sm: 'screen and (max-width:768px)',
    md: 'screen and (min-width:992px)',
    lt_md: 'screen and (max-width:992px)',
    lg: 'screen and (min-width:1200px)',
    lt_lg: 'screen and (max-width:1200px)',
    header_lg_breakpoint: 'screen and (min-width:1024px)',
    lt_header_lg_breakpoint: 'screen and (max-width:1024px)'
};
class MediaQuery {
    static match(query) {
        return window.matchMedia ? window.matchMedia(query).matches : true;
    }
    static is(size) {
        return MediaQuery.match(window.screenBreakpoints[size]);
    }
}
window.MediaQuery = MediaQuery;

;// CONCATENATED MODULE: ./pages/checkout_auth/index.js





const rows = document.querySelectorAll('.row');
if (MediaQuery.is('md')) {
    window.onload = ()=>{
        rows.forEach((row)=>{
            row.classList.add('row-flex');
        });
    };
}

;// CONCATENATED MODULE: ./packs/checkout_auth.js



/***/ }),

/***/ 2259:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * validate v1.1.4: A lightweight form validation script that augments native HTML5 form validation elements and attributes.
 * (c) 2018 Chris Ferdinandi
 * MIT License
 * http://github.com/cferdinandi/validate
 */ (function(root, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory(root)),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else {}
})(typeof (self || window) !== 'undefined' ? (self || window) : this.window || this.global, function(root) {
    'use strict';
    //
    // Variables
    //
    var validate = {}; // Object for public APIs
    var supports = 'querySelector' in document && 'addEventListener' in root; // Feature test
    var settings;
    // Default settings
    var defaults = {
        // Classes and Selectors
        selector: '[data-validate]',
        fieldClass: 'error',
        errorClass: 'error-message',
        // Messages
        messageValueMissing: 'Please fill out this field.',
        messageValueMissingSelect: 'Please select a value.',
        messageValueMissingSelectMulti: 'Please select at least one value.',
        messageTypeMismatchEmail: 'Please enter an email address.',
        messageTypeMismatchURL: 'Please enter a URL.',
        messageTooShort: 'Please lengthen this text to {minLength} characters or more. You are currently using {length} characters.',
        messageTooLong: 'Please shorten this text to no more than {maxLength} characters. You are currently using {length} characters.',
        messagePatternMismatch: 'Please match the requested format.',
        messageBadInput: 'Please enter a number.',
        messageStepMismatch: 'Please select a valid value.',
        messageRangeOverflow: 'Please select a value that is no more than {max}.',
        messageRangeUnderflow: 'Please select a value that is no less than {min}.',
        messageGeneric: 'The value you entered for this field is invalid.',
        customValidity: {},
        // Form Submission
        disableSubmit: false,
        onSubmit: function() {},
        // Callbacks
        beforeShowError: function() {},
        afterShowError: function() {},
        beforeRemoveError: function() {},
        afterRemoveError: function() {}
    };
    //
    // Methods
    //
    // Element.matches() polyfill
    if (!Element.prototype.matches) {
        Element.prototype.matches = Element.prototype.matchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector || Element.prototype.oMatchesSelector || Element.prototype.webkitMatchesSelector || function(s) {
            var matches = (this.document || this.ownerDocument).querySelectorAll(s), i = matches.length;
            while(--i >= 0 && matches.item(i) !== this){}
            return i > -1;
        };
    }
    /**
	 * Merge two or more objects. Returns a new object.
	 * @private
	 * @param {Boolean}  deep     If true, do a deep (or recursive) merge [optional]
	 * @param {Object}   objects  The objects to merge together
	 * @returns {Object}          Merged values of defaults and options
	 */ var extend = function() {
        // Variables
        var extended = {};
        var deep = false;
        var i = 0;
        var length = arguments.length;
        // Check if a deep merge
        if (Object.prototype.toString.call(arguments[0]) === '[object Boolean]') {
            deep = arguments[0];
            i++;
        }
        // Merge the object into the extended object
        var merge = function(obj) {
            for(var prop in obj){
                if (Object.prototype.hasOwnProperty.call(obj, prop)) {
                    // If deep merge and property is an object, merge properties
                    if (deep && Object.prototype.toString.call(obj[prop]) === '[object Object]') {
                        extended[prop] = extend(true, extended[prop], obj[prop]);
                    } else {
                        extended[prop] = obj[prop];
                    }
                }
            }
        };
        // Loop through each object and conduct a merge
        for(; i < length; i++){
            var obj = arguments[i];
            merge(obj);
        }
        return extended;
    };
    /**
	 * Get the closest matching element up the DOM tree.
	 * @private
	 * @param  {Element} elem     Starting element
	 * @param  {String}  selector Selector to match against
	 * @return {Boolean|Element}  Returns null if not match found
	 */ var getClosest = function(elem, selector) {
        for(; elem && elem !== document; elem = elem.parentNode){
            if (elem.matches(selector)) return elem;
        }
        return null;
    };
    /**
	 * Validate a form field
	 * @public
	 * @param  {Node}    field   The field to validate
	 * @param  {Object}  options User options
	 * @return {String}          The error message
	 */ validate.hasError = function(field, options) {
        // Merge user options with existing settings or defaults
        var localSettings = extend(settings || defaults, options || {});
        // Don't validate submits, buttons, file and reset inputs, and disabled fields
        if (field.disabled || field.type === 'file' || field.type === 'reset' || field.type === 'submit' || field.type === 'button') return;
        // Check any custom validity errors
        var customValidityError = null;
        for(var key in localSettings.customValidity){
            if (localSettings.customValidity.hasOwnProperty(key) && localSettings.customValidity[key].check(field)) {
                customValidityError = localSettings.customValidity[key].message;
                break;
            }
        }
        if (customValidityError) return customValidityError;
        // Get validity
        var validity = field.validity;
        // If valid, return null
        if (validity.valid) return;
        // If field is required and empty
        if (validity.valueMissing) {
            if (field.type === 'select-multiple') return localSettings.messageValueMissingSelectMulti;
            if (field.type === 'select-one') return localSettings.messageValueMissingSelect;
            return localSettings.messageValueMissing;
        }
        // If not the right type
        if (validity.typeMismatch) {
            // Email
            if (field.type === 'email') return localSettings.messageTypeMismatchEmail;
            // URL
            if (field.type === 'url') return localSettings.messageTypeMismatchURL;
        }
        // If too short
        if (validity.tooShort) return localSettings.messageTooShort.replace('{minLength}', field.getAttribute('minLength')).replace('{length}', field.value.length);
        // If too long
        if (validity.tooLong) return localSettings.messageTooLong.replace('{minLength}', field.getAttribute('maxLength')).replace('{length}', field.value.length);
        // If number input isn't a number
        if (validity.badInput) return localSettings.messageBadInput;
        // If a number value doesn't match the step interval
        if (validity.stepMismatch) return localSettings.messageStepMismatch;
        // If a number field is over the max
        if (validity.rangeOverflow) return localSettings.messageRangeOverflow.replace('{max}', field.getAttribute('max'));
        // If a number field is below the min
        if (validity.rangeUnderflow) return localSettings.messageRangeUnderflow.replace('{min}', field.getAttribute('min'));
        // If pattern doesn't match
        if (validity.patternMismatch) {
            // If pattern info is included, return custom error
            if (field.hasAttribute('title')) return field.getAttribute('title');
            // Otherwise, generic error
            return localSettings.messagePatternMismatch;
        }
        // If all else fails, return a generic catchall error
        return localSettings.messageGeneric;
    };
    /**
	 * Show an error message on a field
	 * @public
	 * @param  {Node}   field   The field to show an error message for
	 * @param  {String} error   The error message to show
	 * @param  {Object} options User options
	 */ validate.showError = function(field, error, options) {
        // Merge user options with existing settings or defaults
        var localSettings = extend(settings || defaults, options || {});
        // Before show error callback
        localSettings.beforeShowError(field, error);
        // Add error class to field
        field.classList.add(localSettings.fieldClass);
        // If the field is a radio button and part of a group, error all and get the last item in the group
        if (field.type === 'radio' && field.name) {
            var group = document.getElementsByName(field.name);
            if (group.length > 0) {
                for(var i = 0; i < group.length; i++){
                    if (group[i].form !== field.form) continue; // Only check fields in current form
                    group[i].classList.add(localSettings.fieldClass);
                }
                field = group[group.length - 1];
            }
        }
        // Get field id or name
        var id = field.id || field.name;
        if (!id) return;
        // Check if error message field already exists
        // If not, create one
        var message = field.form.querySelector('.' + localSettings.errorClass + '#error-for-' + id);
        if (!message) {
            message = document.createElement('div');
            message.className = localSettings.errorClass;
            message.id = 'error-for-' + id;
            // If the field is a radio button or checkbox, insert error after the label
            var label;
            if (field.type === 'radio' || field.type === 'checkbox') {
                label = field.form.querySelector('label[for="' + id + '"]') || getClosest(field, 'label');
                if (label) {
                    label.parentNode.insertBefore(message, label.nextSibling);
                }
            }
            // Otherwise, insert it after the field
            if (!label) {
                field.parentNode.insertBefore(message, field.nextSibling);
            }
        }
        // Add ARIA role to the field
        field.setAttribute('aria-describedby', 'error-for-' + id);
        // Update error message
        message.innerHTML = error;
        // Remove any existing styles hiding the error message
        message.style.display = '';
        message.style.visibility = '';
        // After show error callback
        localSettings.afterShowError(field, error);
    };
    /**
	 * Remove an error message from a field
	 * @public
	 * @param  {Node}   field   The field to remove the error from
	 * @param  {Object} options User options
	 */ validate.removeError = function(field, options) {
        // Merge user options with existing settings or defaults
        var localSettings = extend(settings || defaults, options || {});
        // Before remove error callback
        localSettings.beforeRemoveError(field);
        // Remove ARIA role from the field
        field.removeAttribute('aria-describedby');
        // Remove error class to field
        field.classList.remove(localSettings.fieldClass);
        // If the field is a radio button and part of a group, remove error from all and get the last item in the group
        if (field.type === 'radio' && field.name) {
            var group = document.getElementsByName(field.name);
            if (group.length > 0) {
                for(var i = 0; i < group.length; i++){
                    if (group[i].form !== field.form) continue; // Only check fields in current form
                    group[i].classList.remove(localSettings.fieldClass);
                }
                field = group[group.length - 1];
            }
        }
        // Get field id or name
        var id = field.id || field.name;
        if (!id) return;
        // Check if an error message is in the DOM
        var message = field.form.querySelector('.' + localSettings.errorClass + '#error-for-' + id + '');
        if (!message) return;
        // If so, hide it
        message.innerHTML = '';
        message.style.display = 'none';
        message.style.visibility = 'hidden';
        // After remove error callback
        localSettings.afterRemoveError(field);
    };
    /**
	 * Add the `novalidate` attribute to all forms
	 * @private
	 * @param {Boolean} remove  If true, remove the `novalidate` attribute
	 */ var addNoValidate = function(remove) {
        var forms = document.querySelectorAll(settings.selector);
        for(var i = 0; i < forms.length; i++){
            if (remove) {
                forms[i].removeAttribute('novalidate');
                continue;
            }
            forms[i].setAttribute('novalidate', true);
        }
    };
    /**
	 * Check field validity when it loses focus
	 * @private
	 * @param  {Event} event The blur event
	 */ var blurHandler = function(event) {
        // Only run if the field is in a form to be validated
        if (!event.target.form || !event.target.form.matches(settings.selector)) return;
        // Validate the field
        var error = validate.hasError(event.target);
        // If there's an error, show it
        if (error) {
            validate.showError(event.target, error);
            return;
        }
        // Otherwise, remove any errors that exist
        validate.removeError(event.target);
    };
    /**
	 * Check radio and checkbox field validity when clicked
	 * @private
	 * @param  {Event} event The click event
	 */ var clickHandler = function(event) {
        // Only run if the field is in a form to be validated
        if (!event.target.form || !event.target.form.matches(settings.selector)) return;
        // Only run if the field is a checkbox or radio
        var type = event.target.getAttribute('type');
        if (!(type === 'checkbox' || type === 'radio')) return;
        // Validate the field
        var error = validate.hasError(event.target);
        // If there's an error, show it
        if (error) {
            validate.showError(event.target, error);
            return;
        }
        // Otherwise, remove any errors that exist
        validate.removeError(event.target);
    };
    /**
	 * Check all fields on submit
	 * @private
	 * @param  {Event} event  The submit event
	 */ var submitHandler = function(event) {
        // Only run on forms flagged for validation
        if (!event.target.matches(settings.selector)) return;
        // Get all of the form elements
        var fields = event.target.elements;
        // Validate each field
        // Store the first field with an error to a variable so we can bring it into focus later
        var hasErrors;
        for(var i = 0; i < fields.length; i++){
            var error = validate.hasError(fields[i]);
            if (error) {
                validate.showError(fields[i], error);
                if (!hasErrors) {
                    hasErrors = fields[i];
                }
            }
        }
        // Prevent form from submitting if there are errors or submission is disabled
        if (hasErrors || settings.disableSubmit) {
            event.preventDefault();
        }
        // If there are errrors, focus on first element with error
        if (hasErrors) {
            hasErrors.focus();
            return;
        }
        // Otherwise, submit the form
        settings.onSubmit(event.target, fields);
    };
    /**
	 * Destroy the current initialization.
	 * @public
	 */ validate.destroy = function() {
        // If plugin isn't already initialized, stop
        if (!settings) return;
        // Remove event listeners
        document.removeEventListener('blur', blurHandler, true);
        document.removeEventListener('click', clickHandler, false);
        document.removeEventListener('submit', submitHandler, false);
        // Remove all errors
        var fields = document.querySelectorAll(settings.errorClass);
        for(var i = 0; i < fields.length; i++){
            validate.removeError(fields[i]);
        }
        // Remove `novalidate` from forms
        addNoValidate(true);
        // Reset variables
        settings = null;
    };
    /**
	 * Initialize Validate
	 * @public
	 * @param {Object} options User settings
	 */ validate.init = function(options) {
        // feature test
        if (!supports) return;
        // Destroy any existing initializations
        validate.destroy();
        // Merge user options with defaults
        settings = extend(defaults, options || {});
        // Add the `novalidate` attribute to all forms
        addNoValidate();
        // Event listeners
        document.addEventListener('blur', blurHandler, true);
        document.addEventListener('click', clickHandler, true);
        document.addEventListener('submit', submitHandler, false);
    };
    //
    // Public APIs
    //
    return validate;
});


/***/ }),

/***/ 82941:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
/*
Copyright (c) 2010,2011,2012,2013,2014 Morgan Roderick http://roderick.dk
License: MIT - http://mrgnrdrck.mit-license.org

https://github.com/mroderick/PubSubJS
*/ (function(root, factory) {
    'use strict';
    var PubSub = {};
    root.PubSub = PubSub;
    var define = root.define;
    factory(PubSub);
    // AMD support
    if (typeof define === 'function' && define.amd) {
        define(function() {
            return PubSub;
        });
    // CommonJS and Node.js module support
    } else if (true) {
        if (module !== undefined && module.exports) {
            exports = module.exports = PubSub; // Node.js specific `module.exports`
        }
        exports.PubSub = PubSub; // CommonJS module 1.1.1 spec
        module.exports = exports = PubSub; // CommonJS
    }
})(typeof window === 'object' && window || this, function(PubSub) {
    'use strict';
    var messages = {}, lastUid = -1;
    function hasKeys(obj) {
        var key;
        for(key in obj){
            if (obj.hasOwnProperty(key)) {
                return true;
            }
        }
        return false;
    }
    /**
	 *	Returns a function that throws the passed exception, for use as argument for setTimeout
	 *	@param { Object } ex An Error object
	 */ function throwException(ex) {
        return function reThrowException() {
            throw ex;
        };
    }
    function callSubscriberWithDelayedExceptions(subscriber, message, data) {
        try {
            subscriber(message, data);
        } catch (ex) {
            setTimeout(throwException(ex), 0);
        }
    }
    function callSubscriberWithImmediateExceptions(subscriber, message, data) {
        subscriber(message, data);
    }
    function deliverMessage(originalMessage, matchedMessage, data, immediateExceptions) {
        var subscribers = messages[matchedMessage], callSubscriber = immediateExceptions ? callSubscriberWithImmediateExceptions : callSubscriberWithDelayedExceptions, s;
        if (!messages.hasOwnProperty(matchedMessage)) {
            return;
        }
        for(s in subscribers){
            if (subscribers.hasOwnProperty(s)) {
                callSubscriber(subscribers[s], originalMessage, data);
            }
        }
    }
    function createDeliveryFunction(message, data, immediateExceptions) {
        return function deliverNamespaced() {
            var topic = String(message), position = topic.lastIndexOf('.');
            // deliver the message as it is now
            deliverMessage(message, message, data, immediateExceptions);
            // trim the hierarchy and deliver message to each level
            while(position !== -1){
                topic = topic.substr(0, position);
                position = topic.lastIndexOf('.');
                deliverMessage(message, topic, data, immediateExceptions);
            }
        };
    }
    function messageHasSubscribers(message) {
        var topic = String(message), found = Boolean(messages.hasOwnProperty(topic) && hasKeys(messages[topic])), position = topic.lastIndexOf('.');
        while(!found && position !== -1){
            topic = topic.substr(0, position);
            position = topic.lastIndexOf('.');
            found = Boolean(messages.hasOwnProperty(topic) && hasKeys(messages[topic]));
        }
        return found;
    }
    function publish(message, data, sync, immediateExceptions) {
        var deliver = createDeliveryFunction(message, data, immediateExceptions), hasSubscribers = messageHasSubscribers(message);
        if (!hasSubscribers) {
            return false;
        }
        if (sync === true) {
            deliver();
        } else {
            setTimeout(deliver, 0);
        }
        return true;
    }
    /**
	 *	PubSub.publish( message[, data] ) -> Boolean
	 *	- message (String): The message to publish
	 *	- data: The data to pass to subscribers
	 *	Publishes the the message, passing the data to it's subscribers
	**/ PubSub.publish = function(message, data) {
        return publish(message, data, false, PubSub.immediateExceptions);
    };
    /**
	 *	PubSub.publishSync( message[, data] ) -> Boolean
	 *	- message (String): The message to publish
	 *	- data: The data to pass to subscribers
	 *	Publishes the the message synchronously, passing the data to it's subscribers
	**/ PubSub.publishSync = function(message, data) {
        return publish(message, data, true, PubSub.immediateExceptions);
    };
    /**
	 *	PubSub.subscribe( message, func ) -> String
	 *	- message (String): The message to subscribe to
	 *	- func (Function): The function to call when a new message is published
	 *	Subscribes the passed function to the passed message. Every returned token is unique and should be stored if
	 *	you need to unsubscribe
	**/ PubSub.subscribe = function(message, func) {
        if (typeof func !== 'function') {
            return false;
        }
        // message is not registered yet
        if (!messages.hasOwnProperty(message)) {
            messages[message] = {};
        }
        // forcing token as String, to allow for future expansions without breaking usage
        // and allow for easy use as key names for the 'messages' object
        var token = 'uid_' + String(++lastUid);
        messages[message][token] = func;
        // return token for unsubscribing
        return token;
    };
    /* Public: Clears all subscriptions
	 */ PubSub.clearAllSubscriptions = function clearAllSubscriptions() {
        messages = {};
    };
    /*Public: Clear subscriptions by the topic
	*/ PubSub.clearSubscriptions = function clearSubscriptions(topic) {
        var m;
        for(m in messages){
            if (messages.hasOwnProperty(m) && m.indexOf(topic) === 0) {
                delete messages[m];
            }
        }
    };
    /* Public: removes subscriptions.
	 * When passed a token, removes a specific subscription.
	 * When passed a function, removes all subscriptions for that function
	 * When passed a topic, removes all subscriptions for that topic (hierarchy)
	 *
	 * value - A token, function or topic to unsubscribe.
	 *
	 * Examples
	 *
	 *		// Example 1 - unsubscribing with a token
	 *		var token = PubSub.subscribe('mytopic', myFunc);
	 *		PubSub.unsubscribe(token);
	 *
	 *		// Example 2 - unsubscribing with a function
	 *		PubSub.unsubscribe(myFunc);
	 *
	 *		// Example 3 - unsubscribing a topic
	 *		PubSub.unsubscribe('mytopic');
	 */ PubSub.unsubscribe = function(value) {
        var descendantTopicExists = function(topic) {
            var m;
            for(m in messages){
                if (messages.hasOwnProperty(m) && m.indexOf(topic) === 0) {
                    // a descendant of the topic exists:
                    return true;
                }
            }
            return false;
        }, isTopic = typeof value === 'string' && (messages.hasOwnProperty(value) || descendantTopicExists(value)), isToken = !isTopic && typeof value === 'string', isFunction = typeof value === 'function', result = false, m, message, t;
        if (isTopic) {
            PubSub.clearSubscriptions(value);
            return;
        }
        for(m in messages){
            if (messages.hasOwnProperty(m)) {
                message = messages[m];
                if (isToken && message[value]) {
                    delete message[value];
                    result = value;
                    break;
                }
                if (isFunction) {
                    for(t in message){
                        if (message.hasOwnProperty(t) && message[t] === value) {
                            delete message[t];
                            result = true;
                        }
                    }
                }
            }
        }
        return result;
    };
});


/***/ }),

/***/ 82786:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "assets/unlimited-professors-9c59debeda97f6ce3673.png";

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			loaded: false,
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/node module decorator */
/******/ 	(() => {
/******/ 		__webpack_require__.nmd = (module) => {
/******/ 			module.paths = [];
/******/ 			if (!module.children) module.children = [];
/******/ 			return module;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	(() => {
/******/ 		__webpack_require__.p = "https://odin.qconcursos.com/packs/";
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			2707: 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkIds[i]] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunk"] = self["webpackChunk"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, [8382,8224], () => (__webpack_require__(5947)))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;